package com.exura.features.userprofile.data.mappers

import com.exura.features.userprofile.data.remote.dto.DoctorProfileDto
import com.exura.features.userprofile.data.remote.dto.OrganizationProfileDto
import com.exura.features.userprofile.data.remote.dto.UserSettingsBaseDto
import com.exura.features.userprofile.domain.model.DoctorProfile
import com.exura.features.userprofile.domain.model.OrganizationProfile
import com.exura.features.userprofile.domain.model.ProviderProfile
import dev.gitlive.firebase.firestore.CollectionReference

class PolymorphicProviderProfileMappers : ProviderUserSettingsMappers<ProviderProfile, UserSettingsBaseDto> {
    private val doctorMapper: DoctorProfileMappers = DoctorProfileMappers()
    private val organizationMapper: OrganizationProfileMappers = OrganizationProfileMappers()

    override fun toDto(model: ProviderProfile): UserSettingsBaseDto = when (model) {
        is DoctorProfile -> doctorMapper.toDto(model)
        is OrganizationProfile -> organizationMapper.toDto(model)
        else -> throw IllegalArgumentException("Unknown provider profile type: ${model::class.simpleName}")
    }

    override fun toDomain(dto: UserSettingsBaseDto, collection: CollectionReference?, id: String?): ProviderProfile = when (dto) {
        is DoctorProfileDto -> doctorMapper.toDomain(dto, collection, id)
        is OrganizationProfileDto -> organizationMapper.toDomain(dto, collection, id)
        else -> throw IllegalArgumentException("Unknown provider profile DTO type: ${dto::class.simpleName}")
    }
}
